// Minutes a new ice time runs when the operator supplies no duration — the create
// form's seed value and the CSV import's fallback for an unmapped Duration column.
export const DEFAULT_SESSION_DURATION_MINUTES = 60;
